import React from 'react';
import PropTypes from 'prop-types';
import { TextInput } from '@els/els-react--text-input';

function SearchInput({ value, onChange }) {
  const isInputEmpty = !value;

  return (
    <TextInput
      className="query-builder-search-section__search-input"
      data-automationId="querybuilder-searchsection-searchinput"
      {...(isInputEmpty
        ? {}
        : {
            iconRight: {
              id: 'query-builder-search-section-search-input',
              sprite: 'Close',
              isDecorative: true,
              a11y: { name: isInputEmpty ? 'Search' : 'Clear' },
            },
          })}
      iconRightCallback={isInputEmpty ? undefined : () => onChange('')}
      label="Search fields and forms"
      shouldHideLabel
      value={value}
      onChange={(e) => onChange(e.target.value)}
    />
  );
}

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
};

export default SearchInput;
